/**
 * description: Used to initialize the web file template\nauthor: hsu.wang@bytedance.com\ndate: 2019-07-16 22:13:03 +0800
 */
import React from 'react'
import { createRoot } from 'react-dom/client'
import _slardar from '@slardar/web'
import compatibleSlardar from '@lib/slardar'
import '@static/css/index.scss'
import { queryParamsFromGlobal, isInApp } from '@src/lib/env_detect'

_slardar('context.merge', queryParamsFromGlobal)
compatibleSlardar.init({
    slardar: _slardar,
})

const init = (pageName, PageComp) => {
    try {
        // 非端内打开，并且来源邮件，重定向到pc promote
        if (!isInApp && queryParamsFromGlobal && queryParamsFromGlobal.from_type === 'email') {
            location.href = '//www.tiktok.com/business-suite/promote'
            return
        }
    } catch {}
    const container = document.getElementById('react-root')
    const root = createRoot(container)
    root.render(<PageComp />)
}

export default init
